import { type IconDefinition, faAndroid, faApple, faLinux, faWindows } from '@fortawesome/free-brands-svg-icons';

export const OSIconMap: { [key: string]: IconDefinition } = {
  windows: faWindows,
  linux: faLinux,
  macos: faApple,
  android: faAndroid,
};
